import ActionTypes from "./ActionTypes";

const getUser = (payload) => {
  return {
    type: ActionTypes.GET_USER,
    payload: payload,
  };
};

const isLogin = (payload) => {
  return {
    type: ActionTypes.IsLogin,
    payload: payload,
  };
};

const EmailNotification = (payload) => {
  console.log("email notification payload", payload);
  return {
    type: ActionTypes.EmailNotification,
    payload: payload,
  };
};

const isLogout = (payload) => {
  return {
    type: ActionTypes.IsLogout,
    payload: payload,
  };
};

export { getUser, isLogin, EmailNotification, isLogout };
